import { genders } from "@api/selectTypes/genders/api";
import { notificationKinds } from "@api/selectTypes/notificationKinds/api";
import { notificationLevel } from "@api/selectTypes/notificationLevel/api";
import { paymentMethods } from "@api/selectTypes/paymentMethods/api";
import { purchaseInvoicesStatus } from "@api/selectTypes/purchaseInvoicesStatus/api";
import { salesInvoicesStatus } from "@api/selectTypes/salesInvoicesStatus/api";
import { salesPriceKind } from "@api/selectTypes/salesPriceKind/api";
import { storeCostKinds } from "@api/selectTypes/storeCostKinds/api";
import { subscriptionStatus } from "@api/selectTypes/subscriptionStatus/api";
import { transactionKinds } from "@api/selectTypes/transactionKinds/api";
import { userRoles } from "@api/selectTypes/userRoles/api";
import { warehouseCirculationEventKinds } from "@api/selectTypes/warehouseCirculationEventKinds/api";
import { warehouseKinds } from "@api/selectTypes/warehouseKinds/api";

export const selectTypes = {
  genders,
  userRoles,
  subscriptionStatus,
  storeCostKinds,
  warehouseKinds,
  warehouseCirculationEventKinds,
  paymentMethods,
  salesInvoicesStatus,
  salesPriceKind,
  purchaseInvoicesStatus,
  transactionKinds,
  notificationKinds,
  notificationLevel,
};
